import setValue from '../../shared/actions/setValue'

export default index => dispatch => dispatch(setValue('pageIndex', index))
